<template>
  <div class="sign-in__charge">
    <div class="relative">
      <div class="bg-color__fff char-line">
        <div class="chang-data">
          <slot name="chart-line__head" />
        </div>
        <span class="time">
          {{ $attrs.time }}
        </span>
        <chart-line
          v-bind="$attrs"
          :chartLineData="$attrs.chartLineData"
          :legendVisible="false"
          :dataEmpty="
            $attrs.chartLineData.rows && $attrs.chartLineData.rows.length === 0
          "
          :chartLineSettings="chartLineSettings"
          :chartOptions="$attrs.chartLineOptions"
          height="32rem"
          :dataZoom="dataZoom"
          :style="{ top: '6rem', padding: '0  2rem' }"
          :colors="['rgba(220, 196, 161, 1)']"
        />
      </div>
      <div class="check-in__show">
        <div class="box">
          <div class="all-in">
            <slot name="check-in__show" />
          </div>
        </div>
        <MapCity
          class="box"
          :chartMapData="$attrs.chartMapData"
          :changeData="$attrs.getVipAreaData"
          :btn="$attrs.signBtn || $attrs.rechargeBtn"
          :pagination="$attrs.signPagination || $attrs.rechargePagination"
        >
          <template #tips>
            <slot name="tips" />
          </template>
        </MapCity>
      </div>
      <slot name="filterInput" />
      <slot name="table" />
      <slot name="pop"></slot>
    </div>
  </div>
</template>
<script>
import chartLine from 'components/Chart/Line/'
import MapCity from 'components/MapCity'
import resize from 'mixins/chartsResize/'

export default {
  name: 'SignInChargeComponent',
  mixins: [resize],
  inheritAttrs: false,
  components: {
    chartLine,
    MapCity
  },
  data() {
    this.chartLineSettings = {
      area: true,
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              // '#c23531','#2f4554', '#61a0a8',
              offset: 0,
              color: 'rgba(220, 196, 161, 1)' // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(220, 196, 161, .1)' // 100% 处的颜色
            }
          ],
          global: false // 缺省为 false
        }
      },
      ...this.$attrs.charLineSetting
    }
    this.dataZoom = [
      {
        type: 'slider',
        start: 0,
        end: 100,
        backgroundColor: 'rgba(220, 196, 161, 0.2)',
        handleStyle: {
          color: 'rgba(220, 196, 161, 1)'
        },
        fillerColor: 'rgba(220, 196, 161, .3)'
      }
    ]
    return {}
  }
}
</script>
<style lang="scss">
.sign-in__charge {
  .bg-color__fff {
    margin-bottom: 1.3rem;
  }

  .char-line {
    position: relative;
    height: 38.8rem;

    .chang-data {
      position: absolute;
      top: 4rem;
      left: 50%;
      transform: translateX(-50%);
      z-index: 200;
    }

    .time {
      position: absolute;
      top: 6rem;
      right: 2.4rem;
    }
  }

  .check-in__show {
    display: flex;
    height: 38.8rem;
    margin-bottom: 1.3rem;
    @extend .clearfix;

    .box {
      flex: 1;
      height: 38.8rem;
      @extend .bg-color__fff;
      display: flex;
      align-items: center;
      justify-content: center;

      &:nth-child(1) {
        margin-right: 0.65rem;
      }

      &:nth-child(2) {
        margin-left: 0.65rem;
        padding: 0 3rem;
      }
    }

    .all-num {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 10.4rem;
      height: 10.4rem;
      background-color: colors('bg-main');
      border-radius: 50%;
      color: #fff;
      text-align: center;

      .num {
        font-size: 1.8rem;
        display: block;
      }
    }

    .icon {
      margin-top: 2.4rem;
    }

    .icon-ren,
    .icon-jine {
      font-size: 1.8rem;

      &:nth-child(2) {
        color: #f9b6e8;
      }

      &:nth-child(3) {
        color: #f9e5b6;
      }

      &:nth-child(4) {
        color: #b6dcf9;
      }

      &:nth-child(5) {
        color: #b6f9bf;
      }

      &:nth-child(6) {
        color: #c2b6f9;
      }
    }
  }
}
</style>
